import { resolveInvoiceStatus } from "./invoices";

export const INVOICE_STATUS_PILL_STYLES = {
  draft: {
    background: "rgba(255,255,255,0.08)",
    color: "rgba(255,255,255,0.72)",
    border: "1px solid rgba(255,255,255,0.16)",
  },
  sent: {
    background: "rgba(201,168,76,0.12)",
    color: "#c9a84c",
    border: "1px solid rgba(201,168,76,0.28)",
  },
  paid: {
    background: "rgba(78,226,161,0.1)",
    color: "#4ee2a1",
    border: "1px solid rgba(78,226,161,0.22)",
  },
  archived: {
    background: "rgba(224,107,90,0.12)",
    color: "#e06b5a",
    border: "1px solid rgba(224,107,90,0.28)",
  },
};

export function getInvoiceStatusPillStyle(status) {
  const resolved = resolveInvoiceStatus(status);
  return (
    INVOICE_STATUS_PILL_STYLES[resolved] || INVOICE_STATUS_PILL_STYLES.draft
  );
}
